import React from 'react';
import DetailsContainer from '../../container-details';
import FilesContainer from '../../container-files';
import MapContainer from '../../container-map';
import StatusContainer from '../../container-status';
import MyActions from '../../my-actions';
import { DashboardContentTopBlock, DashboardContentTopBlockColFirst, DashboardContentTopBlockColSecond, DashboardContentTopBlockLineFirst, DashboardContentTopBlockLineSecond, DashboardDesktopStyled } from './styled';
import PropTypes from 'prop-types';
export const DashboardContentTopBlockRenderer = _ref => {
  let {
    project
  } = _ref;
  return /*#__PURE__*/React.createElement(DashboardContentTopBlock, null, /*#__PURE__*/React.createElement(DashboardContentTopBlockLineFirst, null, /*#__PURE__*/React.createElement(DashboardContentTopBlockColFirst, null, /*#__PURE__*/React.createElement(MapContainer, {
    project: project
  })), /*#__PURE__*/React.createElement(DashboardContentTopBlockColSecond, null, /*#__PURE__*/React.createElement(MyActions, null))), /*#__PURE__*/React.createElement(DashboardContentTopBlockLineSecond, null, /*#__PURE__*/React.createElement(DashboardContentTopBlockColFirst, null, /*#__PURE__*/React.createElement(StatusContainer, {
    project: project
  })), /*#__PURE__*/React.createElement(DashboardContentTopBlockColSecond, null, /*#__PURE__*/React.createElement(DetailsContainer, {
    project: project
  }))));
};
DashboardContentTopBlockRenderer.propTypes = {
  project: PropTypes.object.isRequired
};
const DashboardDesktop = _ref2 => {
  let {
    project
  } = _ref2;
  return /*#__PURE__*/React.createElement(DashboardDesktopStyled, null, /*#__PURE__*/React.createElement(DashboardContentTopBlockRenderer, {
    project: project
  }), /*#__PURE__*/React.createElement(FilesContainer, {
    project: project
  }));
};
DashboardDesktop.propTypes = {
  project: PropTypes.object.isRequired
};
export default DashboardDesktop;